import React from "react";
import {shape, string} from "prop-types";

const OrderSummaryItem = ({
    details
}) => {
    const isShippingInvalid = details.code === "shipping" && !details.code.value;

    const isTaxInvalid = details.code === "tax" && !details.code.value;

    const isShippingOrTaxInvalid = isShippingInvalid || isTaxInvalid;

    if(isShippingOrTaxInvalid) {
        return null;
    }
    return(
        <tr id={details.code}>
            <th>{details.title}</th>
            <td>${details.value}</td>
        </tr>
    );
};

OrderSummaryItem.propTypes = {
    details: shape({
        code: string,
        title: string,
        value: string
    })
};

export default OrderSummaryItem;